import React from "react";
import AppRoutes from "./AppRoutes";
import { AuthProvider } from "../context/AuthContext";
import { NotificationCenterProvider } from "../context/NotificationCenterContext";
import ChatWidget from "../modules/chatbot/ChatWidget";

const AppRoot = () => (
  <AuthProvider>
    <NotificationCenterProvider>
      <AppRoutes />
      <ChatWidget />
    </NotificationCenterProvider>
  </AuthProvider>
);

export default AppRoot;
